import React, { useEffect, useRef, useState } from 'react';
import Header from "../components/Header/Header.jsx";
import SliderBanner from "../components/SliderBanner/SliderBanner.jsx";
import InformationAboutCompany from "../components/InformationAboutСompany/InformationAboutСompany.jsx";
import LinksThePages from "../components/LinksThePages/LinksThePages.jsx";
import Footer from "../components/Footer/Footer.jsx";
import ProjectMap from "../components/ProjectMap/ProjectMap.jsx";
import axios from "axios";

export default function Main({ activeCategory, setActiveCategory }) {
    const nextBlockRef = useRef(null);

    const url = "https://sqn-law.ru:3001";
    const [mapDate, setMapDate] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchData = async (page = 1) => {
            try {
                const response = await axios.get(
                    `${url}/api/project-maps?pagination[page]=${page}&pagination[pageSize]=100&fields[0]=Top&fields[1]=Left&fields[2]=Description`,
                );
                const data = response.data.data;
                if (data.length > 0) {
                    setMapDate(prevData => [...prevData, ...data]);
                    fetchData(page + 1);
                } else {
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("Ошибка при запросе данных:", error);
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="containerSlider">
            <Header activeCategory={activeCategory} mainPage={true} setActiveCategory={setActiveCategory} />
            <SliderBanner nextBlockRef={nextBlockRef} />
            <InformationAboutCompany nextBlockRef={nextBlockRef} />
            <LinksThePages setActiveCategory={setActiveCategory} />
            <ProjectMap mapDate={mapDate}/>
            <Footer mainPage={true} setActiveCategory={setActiveCategory}/>
        </div>
    );
}
